module.exports = __webpack_public_path__ + "static/media/printText.97199012.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/printText.png
// module id = 27
// module chunks = 0